<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'

import datePickerZhCN from 'ant-design-vue/es/date-picker/locale/zh_CN'
import datePickerEnUS from 'ant-design-vue/es/date-picker/locale/en_US'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      locale: zhCN
    }
  },
  provide() {
    return {
      datePickerLang: datePickerZhCN
    }
  },
  created() {
    this.setLang(this.lang)
  },
  computed: {
    ...mapState(['lang'])
  },
  watch: {
    lang(lang) {
      this.setLang(lang)
    }
  },
  methods: {
    getPopupContainer(trigger) {
      return trigger.parentNode || document.body
    },
    setLang(lang) {
      this.$i18n.locale = lang

      switch (lang) {
        case 'zh_CN':
          this.locale = zhCN
          this.datePickerLang = datePickerZhCN
          break
        case 'en_US':
          this.locale = enUS
          this.datePickerLang = datePickerEnUS
          break
      }
    }
  },

  components: {}
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  height: 100%;
  // min-width: 1366px;
  // overflow: auto;
  overflow-y: hidden;
}

.content-warp {
  padding: 16px;
  // max-height: 100%;
  overflow-y: auto !important;

  position: absolute !important;
  bottom: 0;
  top: 88px;
  left: 0;
  right: 0;
}
.content-panle {
  border-radius: 5px;
  padding: 16px;
}
.content-panle .panle-head:before {
  content: '';
  margin-right: 10px;
  border: 2px solid #1890ff;
  border-radius: 5px;
}
.content-panle > .gutter-row > .panle-item {
  background-color: #fff;
  padding: 16px;
  min-height: 670px;
  border-radius: 5px;
  box-shadow: 0 0 20px #e8e8e8;
}

.content-panle .btn-area-inline > .ant-btn {
  margin: 4px 8px 4px 0;
  flex-grow: 1;
}

.table-operation-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  .btn-area-inline {
    flex-grow: 1;

    .ant-btn {
      margin: 4px 8px 4px 0;
    }
  }

  .search-form {
    text-align: right;
    flex-grow: 1;
  }
}

.content-panle .table-area {
  min-height: 544px;
}
.content-panle .table-area .operation-botton {
  border-right: 1px solid #ddd;
  padding: 0 5px;
}
.content-panle .table-area .operation-botton[disabled] {
  opacity: 0.4;
  cursor: not-allowed;
}
.content-panle .table-area .operation-botton:last-child {
  border: none;
}

.form-select {
  z-index: 8 !important;
  text-align: left;
}
.form-date-picker {
  z-index: 8 !important;
}

.ant-table-placeholder {
  border-bottom: unset !important;
}

.bg-white {
  background-color: #fff;
  box-shadow: 0 0 20px #e8e8e8;
}
.margin-0 {
  margin: 0 !important;
}
.padding-0 {
  padding: 0 !important;
}
.padding-tb-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.padding-tb-md {
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>
